import { toBaseStudyEntity } from '../study-entity.js';
import { toVersionedReference } from '../versioned-reference.js';
import { checkDefined } from 'faro-common-model';
import { toDynamicFieldReferenceConstraint, } from './dynamic-field-reference-constraint.js';
import { StudyEntityType } from '../study-entity-type.js';
export const dynamicFieldNameMaxLength = 60;
export function toDynamicField(field) {
    checkDefined(field.definition, 'DynamicField', 'definition');
    return {
        ...toBaseStudyEntity(field, StudyEntityType.StudyDynamicField),
        name: field.name,
        expression: field.expression,
        entityReferences: (field.entityReferences || []).map(toDynamicFieldEntityReference),
        definition: toVersionedReference(field.definition),
    };
}
export function toDynamicFieldEntityReference(reference) {
    checkDefined(reference.name, 'DynamicFieldEntityReference', 'name');
    checkDefined(reference.type, 'DynamicFieldEntityReference', 'type');
    return {
        name: reference.name,
        code: reference.code,
        type: reference.type,
        id: reference.id,
        constraint: reference.constraint == null ? undefined : toDynamicFieldReferenceConstraint(reference.constraint),
    };
}
//# sourceMappingURL=dynamic-field.js.map